
import CustomBlock from "@wd/cms-pc";
import CmsBlock from '../modules/CmsBlock';
import CreateBlock from '../modules/CreateBlock.js';
import _ from 'lodash'
export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    renderOnly: {
      type: Boolean,
    },
  },
  data() {
    return {
      compList: [],
      parentId: 0,
      dragData: null,
      direction: 'bottom',//拖动位置
    };
  },
  components: {
    // DynamicBlock,
    CustomBlock,
    CmsBlock,
    CreateBlock
  },
  methods: {
    dataParser(json) {
      if (_.isPlainObject(json)) {
        const obj = {}
        const keys = _.keys(json)
        keys.forEach((k) => {
          let tarValue = _.get(json[`${k}`], 'value', undefined)
          if (_.isObject(tarValue)) {
            tarValue = this.dataParser(tarValue)
          }
          _.set(obj, k, tarValue)
        })
        return obj
      } else if (_.isArray(json)) {
        const arr = []
        json.forEach(j => {
          let tarValue = _.get(j, 'value', undefined)
          if (_.isObject(tarValue)) {
            tarValue = this.dataParser(tarValue)
          }
          tarValue && arr.push(tarValue)
        })
        return arr
      }
    },
    //获取拖动的数据
    getdargData(dargId, dataList) {
      dataList.map(element => {
        if (element.id == dargId) {
          this.dragData = element
        } else {
          if (element.children) {
            this.getdargData(dargId, element.children)
          }
          return
        }
      });
      return this.dragData
    },
    findParentByClass(elem, c) {
      let container = elem;
      while (container.tagName !== 'BODY'
        && !container.classList.contains(c)) {
        container = container.parentNode;
      }
      return container.tagName === 'BODY' ? null : container;
    },
    //获取
    getIdPostion(positionId, data, dataList) {
      dataList.map((element) => {
        if (element.id === positionId) {
          element.children.push(data)
          return element
        } else {
          if (element.children) {
            this.getIdPostion(positionId, data, element.children)
          }
        }
      });
    },
    getBlockPostion(id, data, datalist) {
      datalist.map((element) => {
        console.log('element.id----', element.id, id)
        if (element.id === id) {
          datalist.push(data)
        } else if (element.children) {
          this.getBlockPostion(id, data, element.children)
        }
      });
    },
    renderConfig(h, data) {
      console.log('data====', data)
      if (!data) { return console.error('no data'); }
      let childNodes = [];
      const option = {};
      option.class = data.class || {};
      option.style = data.style || {};
      option.attrs = data.attrs || {};
      option.props = data.props || {};
      option.domProps = data.domProps || {};
      option.on = data.on || {};
      option.nativeOn = data.nativeOn || {};
      option.ref = data.ref || data.id;
      option.key = data.key || data.id;
      if (data.tag === 'div') {
        delete option.nativeOn;
      }
      if (data.id) {
        option.attrs['data-id'] = `${data.id}`;
        option.attrs['data-comp-name'] = `${data.name}` || `{data.type}`;
        option.class[`dynamic-comp-id-${data.id}`] = true;
        option.class['isroot'] = data.rootElem;
      }
      if (data.tag === 'el-col') {
        option.props.name = data.name;
        option.attrs['data-id'] = `${data.id}`;
        option.attrs['span'] = data.span;
        option.class[`dynamic-comp-id-${data.id}`] = true;
      }
      if(data.tag === 'el-tabs') {
        option.attrs['stretch']= data.stretch;
        option.attrs['navBold'] = data.style.navBold
        option.attrs['navFontSize'] = data.style.navFontSize
        option.attrs['backgroundColor'] = data.style.backgroundColor
        option.attrs['navHoverColor'] = data.style.navHoverColor
        option.attrs['navBcColor'] = data.style.navBcColor
        option.attrs['navColor'] = data.style.navColor
        option.attrs['tabsWidth'] = data.style.tabsWidth+'px'
      }
      if (data.children) {
        childNodes = data.children.map((n) => this.renderConfig(h, n));
      }

      if (data.type === 'block' || data.tag === 'dynamic-block') {
        // if(data.isDefined){
        option.props.name = data.name;
        // } else {
        //   option.props.name = data.label;
        // }
        option.props.blockInfo = {
          id: data.id,
          label: data.label,
          name: data.name,
        };
        // if(data.isDefined){
        const settings = this.$store.getters.storeGetBlockSettings(option.props.blockInfo);
        console.log('settings---->',settings)
        let newSetting;
        if (settings) {
          if(settings.settingLayout){
            newSetting = this.dataParser(settings.setting)
            option.props.receiveProps = newSetting[0]
          } else {
            option.props.receiveProps = settings.setting[0]
          }
        }  
        if(data.name.split('-')[0] === 'product'){
          option.props.uri = data.uri;
          option.props.name = data.name.split('-')[1];
          return h('create-block', option, childNodes);
          
        } else {
          const isCMS = settings && settings.module === 'cms';
          if (isCMS) {
            option.props.name = settings.name
            option.props.code = settings.name
            option.props.data = settings
            return h('cms-block', option, childNodes);
          } else {
            return h('custom-block', option, childNodes);
          }
        }

      } else {
        return h(data.tag, option, childNodes);
      }
    }
  },
  render(h) {
    this.compList = this.data;
    const childNodes = this.compList.map((n) => this.renderConfig(h, n));
    console.log('childNodes----', childNodes)
    const result = h('div', childNodes);
    return result;
  }
};
